import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export const PermitTypeCardSkeleton: React.FC = () => {
  return (
    <Card
      sx={{
        border: 2,
        borderColor: "divider",
      }}
    >
      <CardContent sx={{ pb: 1 }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1.5 }}>
          <Skeleton variant="text" width="60%" height={32} />
        </Box>

        {/* Description */}
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="80%" sx={{ mb: 2 }} />

        {/* Info Grid - 2x2 */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 2,
            mb: 2,
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
              <Skeleton variant="circular" width={20} height={20} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="50%" height={16} />
                <Skeleton variant="text" width="70%" height={20} />
              </Box>
            </Box>
          ))}
        </Box>

        {/* Required Documents */}
        <Box sx={{ borderTop: 1, borderColor: "divider", pt: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width="40%" height={24} />
          </Box>
        </Box>
      </CardContent>

      {/* Select Button */}
      <CardActions sx={{ px: 2, pb: 2, pt: 0 }}>
        <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: 1 }} />
      </CardActions>
    </Card>
  );
};

export default PermitTypeCardSkeleton;
